<template>
  <div class="signup-container" style="
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: stretch;
      padding: 10px;
      height: 100%;
      font-family: 'Helvetica' !important;
    ">
    <FormHeader title=""
      :secondaryTitle="current_step == 'type_select' ? 'text.type_subtitle' : 'text.method_subtitle'" />
    <div class="form" style="
          background-color: #ecf4f6;
          padding: 5%;
          display: flex;
          flex-direction: column;
          align-items: stretch;
          gap: 10px;
          margin: 2%;
        ">
      <div v-if="current_step == 'method_select' && type" style="
              display: flex;
              flex-direction: row;
              align-items: stretch;
              gap: 10px;
            ">
        <button :class="['btn btn-card', { active: method == 'unique' }]" :style="{
        display: 'flex',
        fontFamily: 'Helvetica',
        border: '1px solid #264c78',
        flexDirection: 'column',
        justifyContent: 'start',
        alignItems: 'center',
        gap: '1em'
      }" @click="setMethod('unique')">
          <p style="color:#747474">{{ paymentInfo[type].unique.subtitle }}</p>
          <p style="color:#264c78; font-size: 3em;width: 70%;">{{ paymentInfo[type].unique.title }}</p>
          <ul style="
              color: rgb(116, 116, 116);
                font-size: 0.8em;
                max-width: 120px;
                text-align: start;
                padding-left: 0;">
            <li v-for="detail in paymentInfo[type].unique.details" :key="detail"> {{ detail }}</li>
          </ul>
        </button>
        <button :class="['btn btn-card', { active: method == 'monthly' }]" style="
                display: flex;
                font-family: Helvetica;
                border: 1px solid rgb(38, 76, 120);
                flex-direction: column;
                justify-content: space-between;
                gap: 1em;
                align-items: center;
            " @click="setMethod('monthly')">
          <p style="color:#747474">{{ paymentInfo[type].monthly.subtitle }}</p>
          <p style="color:#264c78; font-size:3em;width: 70%;">{{ paymentInfo[type].monthly.title }}</p>
          <ul style="
                color: rgb(116, 116, 116);
                font-size: 0.8em;
                max-width: 120px;
                text-align: start;
                padding-left: 0px;">
            <li v-for="detail in paymentInfo[type].monthly.details" :key="detail"> {{ detail }}</li>
          </ul>
        </button>
      </div>
      <div v-else style="
            display: flex;
            flex-direction: column;
            align-items: stretch;
            gap: 10px;
          ">
        <div style="display: flex; align-items: stretch; gap: 10px">
          <button :class="['btn btn-card', { active: type == '14h' }]" style="
                aspect-ratio: 3/2;
                display: flex;
                justify-content: center;
                align-items: center;
                font-family: 'Helvetica';
                font-size: 2em;
                border: 1px solid #264c78;
                color: #264c78;
              " @click="setType('14h')">
            14h
          </button>
          <button :class="['btn btn-card', { active: type == '42h' }]" style="
                aspect-ratio: 3/2;
                display: flex;
                justify-content: center;
                align-items: center;
                font-family: 'Helvetica';
                font-size: 2em;
                border: 1px solid #264c78;
                color: #264c78;
              " @click="setType('42h')">
            42h
          </button>
        </div>
        <div
          style="border: 1px solid #8D8D8D; padding: 0.5em 0.1em; border-radius: 0.5em; color: #8D8D8D; font-size: 0.75em; font-family: 'Helvetica'">
          <ul>
            <li>Live chat 24/7 par intelligence artificielle</li>
            <li>Débutant à Expert</li>
            <li>QCMs et score final</li>
            <li>Hotline par mail (1 question / mois offerte)</li>
            <li>Attestation de formation (valable pour renouvellement carte Transaction, Gestion, Syndic)</li>
          </ul>
        </div>
      </div>
      <div style="display:flex; justify-content:space-evenly">
        <button
          style="background-color: #74747428; color: #5A5A5A; border: 0.01em solid black; border-radius: 5em; font-family: 'Helvetica'; font-size: 0.7em; font-weight:600; padding: 0.6em 3em"
          @click="backButton">Retour</button>
        <button :disabled="!type"
          style="background-color: #264C78; color: white; border: 0.01em solid black; border-radius: 5em; font-family: 'Helvetica'; font-size: 0.7em; font-weight:600; padding: 0.6em 3em"
          @click="submitButton">Valider</button>
      </div>
    </div>

  </div>
</template>
<script>
import { customLogger } from "../../utils";
import FormHeader from "../customs/FormHeader_Formacast.vue";
import paytmentCss from "!raw-loader!@/assets/payment.css";

export default {
  name: "SignupForm",
  components: {
    FormHeader,
  },
  props: {
    /**
     * @param {string} redirect - name of the redirect to change to
     * @return {void}
     */
    redirect: {
      type: Function,
      required: false,
      default: () => {
        customLogger("Redirect Called");
      },
    },
  },
  data() {
    return {
      type: null, // 14h or 42h
      method: null, // unique or monthly
      current_step: 'type_select', // type_select or method_select
      paymentInfo: {
        '14h': {
          unique: {
            title: "Flash\n169€",
            subtitle: "Paiement unique",
            details: ["Accès pendant 60 jours", "Délivrance d’une attestation de 14h"]
          },
          monthly: {
            title: "Abo.\n19€",
            subtitle: "Paiement mensuel",
            details: ["Accès illimité", "Délivrance d’une attestation de 14h toutes les 14h de formation"]
          }
        },
        "42h": {
          unique: {
            title: "Flash\n419€",
            subtitle: "Paiement unique",
            details: ["Accès pendant 60 jours", "Délivrance d’une attestation de 42h"]
          },
          monthly: {
            title: "Abo.\n49€",
            subtitle: "Paiement mensuel",
            details: ["Accès illimité", "Délivrance d’une attestation de 42h toutes les 42h de formation"]
          }
        }
      }
    };
  },
  computed: {},
  created() {
    this.appendStyle();
  },
  methods: {
    appendStyle() {
      const iframe = document.getElementById("cleed-frame");
      const doc = iframe.contentWindow.document

      const style = doc.createElement("style");
      style.innerHTML = paytmentCss;
      doc.body.appendChild(style);

    },
    setType(type) {
      this.type = type;
    },
    setMethod(method) {
      this.method = method;
    },
    submitButton() {
      if (this.current_step == 'type_select') {
        if (this.type) this.current_step = 'method_select';

      }
      if (this.current_step == 'method_select') {
        if (this.method) {
          this.redirect("payment", this.type, this.method)
        }
      }

    },

    backButton() {
      if (this.type) {
        this.type = null;
        this.method = null;
        this.current_step = 'type_select';
      } else {
        this.$store.dispatch("LOGOUT");
      }
    },

    redirectTo() {
      this.redirect("payment");
    },
  },
};
</script>
